module.exports = __webpack_public_path__ + "img/bg_06.1ff42452.png";